module.exports = __webpack_public_path__ + "img/tag_gaoji.876570ed.svg";